(function () {
  "use strict";

  function initializeSquatCalculator() {
    var root = document.getElementById("toSquatCalc");
    if (!root || root.dataset.initialized === "true") {
      return;
    }
    root.dataset.initialized = "true";

    var resultMessage = root.querySelector("[data-squat-message]");
    var outputs = root.querySelector("[data-squat-outputs]");
    var tableWrap = root.querySelector("[data-squat-table-wrap]");
    var tableBody = root.querySelector("[data-squat-table-body]");

    function valueFor(selector) {
      var input = root.querySelector(selector);
      return Number(String(input.value).replace(",", "."));
    }

    function roundToPlate(weight) {
      return Math.round(weight / 2.5) * 2.5;
    }

    function formatKg(weight) {
      return weight.toLocaleString("fi-FI", {
        minimumFractionDigits: weight % 1 ? 1 : 0,
        maximumFractionDigits: 1
      }) + " kg";
    }

    function estimatedOneRm(weight, reps) {
      return reps === 1 ? weight : weight * (1 + reps / 30);
    }

    function estimatedSetWeight(oneRm, reps) {
      return reps === 1 ? oneRm : oneRm / (1 + reps / 30);
    }

    function accuracyFor(reps) {
      if (reps <= 5) return "Hyvä";
      if (reps <= 10) return "Kohtalainen";
      return "Suuntaa antava";
    }

    function setMessage(message) {
      resultMessage.textContent = message;
    }

    function hideResults() {
      outputs.hidden = true;
      tableWrap.hidden = true;
    }

    function setActivePill(group, activeButton) {
      group.querySelectorAll("button").forEach(function (button) {
        button.classList.toggle("active", button === activeButton);
      });
    }

    root.querySelectorAll("[data-squat-tab]").forEach(function (tab) {
      tab.addEventListener("click", function () {
        var mode = tab.dataset.squatTab;
        root.querySelectorAll("[data-squat-tab]").forEach(function (button) {
          button.classList.toggle("active", button === tab);
        });
        root.querySelectorAll("[data-squat-panel]").forEach(function (panel) {
          panel.hidden = panel.dataset.squatPanel !== mode;
        });
        hideResults();
        setMessage("Syötä laskentaan tarvittavat tiedot.");
      });
    });

    root.querySelectorAll("[data-squat-rep-group]").forEach(function (group) {
      group.querySelectorAll("button").forEach(function (button) {
        button.addEventListener("click", function () {
          root.querySelector(group.dataset.squatRepGroup).value = button.dataset.reps;
          setActivePill(group, button);
        });
      });
    });

    root.querySelector("[data-calculate-squat-max]").addEventListener("click", function () {
      var weight = valueFor("#toSquatWeight");
      var reps = valueFor("#toSquatReps");
      if (!(weight > 0) || !(reps >= 1 && reps <= 20)) {
        hideResults();
        setMessage("Syötä käyttämäsi paino ja toistomäärä väliltä 1–20.");
        return;
      }

      var oneRm = roundToPlate(estimatedOneRm(weight, reps));
      root.querySelector("[data-squat-one-rm]").textContent = formatKg(oneRm);
      root.querySelector("[data-squat-training-weight]").textContent = formatKg(roundToPlate(oneRm * 0.8));
      root.querySelector("[data-squat-accuracy]").textContent = accuracyFor(reps);
      outputs.hidden = false;
      tableWrap.hidden = true;
      setMessage("Arvioitu kyykyn yhden toiston maksimisi on " + formatKg(oneRm) + ".");
    });

    root.querySelector("[data-calculate-squat-set]").addEventListener("click", function () {
      var oneRm = valueFor("#toSquatOneRm");
      var reps = valueFor("#toSquatTargetReps");
      if (!(oneRm > 0) || !(reps >= 1 && reps <= 20)) {
        hideResults();
        setMessage("Syötä kyykkymaksimisi ja tavoitetoistot väliltä 1–20.");
        return;
      }

      hideResults();
      setMessage("Arvioitu sarjapaino " + reps + " toistolle on " + formatKg(roundToPlate(estimatedSetWeight(oneRm, reps))) + ".");
    });

    root.querySelector("[data-calculate-squat-table]").addEventListener("click", function () {
      var oneRm = valueFor("#toSquatTableMax");
      var purposes = {
        1: "Maksimivoiman arvio",
        3: "Raskas voimaharjoittelu",
        5: "Voimaharjoittelu",
        6: "Voima ja lihaskasvu",
        8: "Lihaskasvu",
        10: "Lihaskasvu",
        12: "Volyymi ja lihaskasvu",
        15: "Kevyt volyymi",
        20: "Tekniikka ja kestävyys"
      };

      if (!(oneRm > 0)) {
        hideResults();
        setMessage("Syötä arvioitu kyykyn yhden toiston maksimisi.");
        return;
      }

      tableBody.innerHTML = "";
      Object.keys(purposes).forEach(function (reps) {
        var row = document.createElement("tr");
        [reps, formatKg(roundToPlate(estimatedSetWeight(oneRm, Number(reps)))), purposes[reps]].forEach(function (text) {
          var cell = document.createElement("td");
          cell.textContent = text;
          row.appendChild(cell);
        });
        tableBody.appendChild(row);
      });

      outputs.hidden = true;
      tableWrap.hidden = false;
      setMessage("Sarjapainot on laskettu kyykkymaksimilla " + formatKg(oneRm) + ".");
    });

    root.querySelector("[data-reset-squat]").addEventListener("click", function () {
      root.querySelectorAll("input").forEach(function (input) {
        input.value = "";
      });
      root.querySelectorAll(".to-squat-calc__pill").forEach(function (button) {
        button.classList.remove("active");
      });
      hideResults();
      tableBody.innerHTML = "";
      setMessage("Syötä paino ja toistomäärä tai arvioitu kyykkymaksimi.");
    });
  }

  initializeSquatCalculator();
  document.addEventListener("DOMContentLoaded", initializeSquatCalculator);
  window.addEventListener("pageshow", initializeSquatCalculator);
  document.addEventListener("shopify:section:load", initializeSquatCalculator);
}());
